import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import URLs from '../../../../../utils/appURLs';
import axiosInstance from '../../../../../app/config/axiosInstance';

type ThunkArgs = any;
type ReturnedType = any;

interface InitialState {
  isLoading: boolean;
  data: any;
  error: any;
}

const initialState: InitialState = {
  isLoading: false,
  data: [],
  error: null
};

export const speedFrequencyAction = createAsyncThunk<ReturnedType, ThunkArgs>(
  'livetracking/speedfrequency',
  async deviceID => {
    const startDate = Math.floor(
      new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
    );
    const endDate = Math.floor(new Date().getTime() / 1000);

    const response = await axiosInstance({
      method: 'GET',
      url: `${URLs.SPEED_FREQUENCY}${deviceID}&startdate=${startDate}&enddate=${endDate}`
    });
    return response?.data?.data;
  }
);

const speedFrequencySlice = createSlice({
  name: 'speedfrequency',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(speedFrequencyAction.pending, state => {
        state.isLoading = true;
        state.data = current(state).data;
        state.error = null;
      })
      .addCase(speedFrequencyAction.fulfilled, (state, action) => {
        const data = action.payload;
        state.isLoading = false;

        state.data =
          data?.length > 0
            ? data?.map(({ speed, count }: any) => ({
                x: parseInt(speed),
                y: count,
                color:
                  (speed >= 0 && speed <= 20) || (speed >= 101 && speed <= 120)
                    ? 'red'
                    : (speed >= 21 && speed <= 40) || (speed >= 81 && speed <= 100)
                    ? 'orange'
                    : 'green'
              }))
            : [];

        state.error = null;
      })
      .addCase(speedFrequencyAction.rejected, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      });
  }
});

export default speedFrequencySlice.reducer;
